var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "form",
      staticClass: "col-12",
      attrs: { id: "change-brokerage-form" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.handleInitialSubmit.apply(null, arguments)
        },
        change: _vm.handleFormChange,
      },
    },
    [
      _c("div", { staticClass: "card" }, [
        _c("ul", { staticClass: "list-group list-group-flush" }, [
          _c("li", { staticClass: "list-group-item" }, [
            _c("h6", { staticClass: "grey-text text-darken-3 m-0" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("settings.accountTab.siteURL")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _c("div", { staticClass: "settings-container mx-0 col-lg-10" }, [
              _c("div", { staticClass: "row moregage-form" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "p",
                    {
                      staticClass:
                        "bg-clear-gray d-block mb-3 px-4 py-1 text-center",
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t(
                              "settings.accountTab.pleaseNoteChangingThisWillAlsoChange"
                            )
                          ) +
                          "\n                "
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-capitalize" }, [
                        _vm._v(_vm._s(_vm.$t("settings.accountTab.please"))),
                      ]),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("settings.accountTab.ensureToUpdateLinks")
                          ) + " "
                        ),
                      ]),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("settings.accountTab.updateLinksIe")) +
                          "\n              "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group-material-flex",
                      attrs: {
                        "data-toggle": "tooltip",
                        "data-placement": _vm.tooltipPosition,
                        title: _vm.isDisabled ? _vm.disabledTooltipTitle : "",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "material-input form-group-material w-auto",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "material-input material-input form app-form form-control form-control-filled domain-text",
                              attrs: { id: "website-addon", disabled: "" },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("portalDomain")("broker", "false")
                                  ) +
                                  "\n                  "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "title text-light-gray mb-2 mb-lg-0",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("settings.accountTab.accountDomain")
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("material-input", {
                        staticClass: "form-group-material-grow",
                        attrs: {
                          disabled: _vm.isDisabled,
                          label: _vm.$t("settings.accountTab.portalDomain"),
                          "label-for": "account-subdomain",
                          placeholder: _vm.$t(
                            "settings.accountTab.portalDomain"
                          ),
                        },
                        model: {
                          value: _vm.subdomain,
                          callback: function ($$v) {
                            _vm.subdomain = $$v
                          },
                          expression: "subdomain",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "my-auto pl-2" }, [
                        _c("i", {
                          staticClass:
                            "clickable fa fa-clipboard copy-link text-primary",
                          attrs: {
                            id: "copy-link-broker",
                            "data-toggle": "tooltip",
                            "data-placement": "bottom",
                            "data-trigger": "click",
                            title: _vm.showBrokerTooltip
                              ? _vm.clipboardTitle
                              : "",
                            "aria-hidden": "true",
                          },
                          on: { click: _vm.handleCopyBrokerage },
                        }),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row moregage-form" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group-material-flex",
                      attrs: {
                        "data-toggle": "tooltip",
                        "data-placement": _vm.tooltipPosition,
                        title: _vm.isDisabled ? _vm.disabledTooltipTitle : "",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "material-input form-group-material w-auto",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "material-input material-input form app-form form-control form-control-filled domain-text-client",
                              attrs: { disabled: "" },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("portalDomain")("client", "false")
                                  ) +
                                  "\n                  "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "title text-light-gray mb-2 mb-lg-0",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("settings.accountTab.clientDomain")
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "form-group-material form-group-material-grow",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.subdomain,
                                expression: "subdomain",
                              },
                            ],
                            staticClass:
                              "material-input subdomain form-control form",
                            attrs: {
                              id: "subdomain-text-client",
                              required: "",
                              readonly: "",
                              disabled: _vm.isDisabled,
                              type: "text",
                              placeholder: _vm.$t(
                                "settings.accountTab.portalSubdomain"
                              ),
                            },
                            domProps: { value: _vm.subdomain },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.subdomain = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              attrs: {
                                for: "subdomain-text-client",
                                hidden: "",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("settings.accountTab.portalSubdomain")
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "my-auto pl-2" }, [
                        _c("i", {
                          staticClass:
                            "clickable fa fa-clipboard copy-link text-primary",
                          attrs: {
                            id: "copy-link-client",
                            "data-toggle": "tooltip",
                            "data-placement": "bottom",
                            "data-trigger": "click",
                            title: _vm.showClientTooltip
                              ? _vm.clipboardTitle
                              : "",
                            "aria-hidden": "true",
                          },
                          on: { click: _vm.handleCopyClient },
                        }),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }